export const ADD_MESSAGE_AND_SCROLL_TO_TOP = 'add-message-and-scroll-to-top';
const addMessageAndScrollToTop = payload => (
  { type: ADD_MESSAGE_AND_SCROLL_TO_TOP, payload }
);
export default addMessageAndScrollToTop;
